var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 491.3 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#22272e;}.cls-2{fill:#f4c2c9;}.cls-3{fill:#ffe779;}.cls-4,.cls-6{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:5.43px;}.cls-4{stroke:#63737a;}.cls-5{fill:#6dafa7;}.cls-6{stroke:#e26e85;}.cls-7{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290,112.1s-4.22,4.22,3.62,36.22,25.66,56.44,25.66,56.44a55.62,55.62,0,0,0,16-52.52C328.6,119,290,112.1,290,112.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M294.49,206.27s-6,1.81-20.22,16.6-35,22.33-59.76,33.5-36.83-40.75-30.49-67c6-26.26,33.2-44.37,33.2-44.37L270,152.24s17.51-20.83,24.45-7.25C301.13,158.58,300.53,189.06,294.49,206.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.22,302.55,69.33,343.9A14.56,14.56,0,0,1,51.82,333L.82,112.1A14.55,14.55,0,0,1,11.68,94.59L191.57,53.24a14.55,14.55,0,0,1,17.5,10.87L259.78,285A14.16,14.16,0,0,1,249.22,302.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M173.46,116.62,56.35,143.49a7,7,0,0,1-8.45-5.44h0a7,7,0,0,1,5.43-8.45l117.11-26.86a7,7,0,0,1,8.45,5.43h0A7.63,7.63,0,0,1,173.46,116.62Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 56.05,
    y1: 174.57,
    x2: 187.04,
    y2: 144.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 61.18,
    y1: 196.61,
    x2: 192.17,
    y2: 166.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.35,283.53,91.06,294.7a7,7,0,0,1-8.45-5.43L71.44,241a7,7,0,0,1,5.44-8.45l48.29-11.16a7,7,0,0,1,8.45,5.43l11.17,48.29A7.65,7.65,0,0,1,139.35,283.53Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 151.43,
    y1: 215.02,
    x2: 200.62,
    y2: 203.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 156.86,
    y1: 238.86,
    x2: 206.36,
    y2: 227.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 162.29,
    y1: 263.01,
    x2: 192.17,
    y2: 256.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M135.43,73.16,71.44,88A6.38,6.38,0,0,1,63.9,80.4l.6-3a6.53,6.53,0,0,1,4.83-4.83L130.6,58.37a6.27,6.27,0,0,1,6.34,2.11l1.81,2.42C141.77,66.82,140,72.26,135.43,73.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.27,133.83s-7.55,3.92-22,0-16.9-7.55-32-11.47-35.92.3-39.54,6.64,6,10.26,19,11.77,19,26.26,39.84,35.61C274.27,191.78,305.05,144.69,274.27,133.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M180.7,129c-3.62,6.34,6,10.26,19,11.77s19,26.26,39.84,35.61a33.13,33.13,0,0,0,20.52,2.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M297.21,119.94s-16,10.27-22.94,13.89c0,0,13.58,13.28,19,37.12s1.21,35.32,1.21,35.32,17.81-1.82,26.56-8.15c0,0,8.45-13.89,1.51-41.05S297.21,119.94,297.21,119.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M486.75,83.12a60.81,60.81,0,0,0-93.26-32.29c-19.92,13.88-40.75,27.46-57.35,36.52L290,112.4s26.26,25.95,30.19,54.63-.91,38-.91,38,72.14-17.81,135.82-48.9c26.86-13.58,40.44-44.37,31.69-73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313.2,183a3.62,3.62,0,1,0-3.62,3.63A3.49,3.49,0,0,0,313.2,183Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.fcc9a3cd5bf56b6a5e9d43b731e695b2.svg";
export { ForwardRef as ReactComponent };